import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=0536d324&scoped=true&"
import script from "./Playlist.vue?vue&type=script&lang=ts&"
export * from "./Playlist.vue?vue&type=script&lang=ts&"
import style0 from "./Playlist.vue?vue&type=style&index=0&id=0536d324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536d324",
  null
  
)

export default component.exports